import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Footnote1, Title4 } from '@sbol/nova';
import type { Question } from '../types';
import styles from './QuestionText.module.scss';

export const QuestionText: FC<{ question: Question }> = observer(({ question }) => {
  return (
    <>
      <Title4 className={styles.question_text}>{question.question_text}</Title4>

      {!!question.question_hint && (
        <Footnote1 color="secondary" className={styles.question_hint}>
          {question.question_hint}
        </Footnote1>
      )}
    </>
  );
});
